import { render, staticRenderFns } from "./VehiclePL.vue?vue&type=template&id=af637bf4&scoped=true&"
import script from "./VehiclePL.vue?vue&type=script&lang=js&"
export * from "./VehiclePL.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af637bf4",
  null
  
)

export default component.exports